module.exports = __webpack_public_path__ + "static/media/brand-all.66f47e2f.png";